/* eslint-disable */

import React, { useEffect, useReducer, useRef, useState } from "react";
import { useForm } from "react-hook-form";
import { Form } from "react-bootstrap";
import { ArrowLeft } from "react-feather";
import { NotificationManager } from "react-notifications";
import { editRegulationsRequestsStatus } from "dictionary/domains/EditRegulationsRequests";
import FeatureLayer from "@arcgis/core/layers/FeatureLayer";
import api from "api";
import EmployeeRequestsCard from "components/EmployeeRequestsCard";
import performActionOnFeature from "utils/performActionOnFeature";
import handleZoom from "utils/handleZoom";
import Dialog from "components/Dialog/Dialog";
import useGetAllZones from "customHooks/useGetAllZones";
import useRoles from "customHooks/useRoles";
import getEsriData from "context/contextFunctions/getEsriData";
import { useMap } from "context/mapContext";
import { useEsriUrls } from "context/esriUrlsContext";
import { useAuth } from "context/auth";
import useFilter from "customHooks/useFilter";
import { useLoading, handleLoading } from "context/LoadingContext";
import addNewLog from "utils/addNewLog";
import { dialogReducer, dialogInitState } from "reducers/dialog";
import EditParcelZoneCard from "components/EditParcelZoneCard.js";
import ParcelLaws from "../../ParcelsSearch/components/ParcelLaws";
import FilesModal from "../../ParcelsSearch/components/FilesModal";
import { generateTextFromJson } from "utils/generateTextFromJson";
import { ErrorHandelFunctionApp } from "utils/ErrorHandelFunction";

function selectedItemReducer(state, action) {
  switch (action.type) {
    case "set": {
      return { ...state, ...action.payload };
    }
    default: {
      throw new Error(`Unhandled action type: ${action.type}`);
    }
  }
}

const reducerInitValue = {
  // type will be "parcelsChange" : "zoneChange"
  type: "",
  // selected item will be zone request or parcel change request
  selectedItem: null,
  // selected zone for modal (this is the original zone before change it)
  selectedZone: null,
  selectedParcels: null,
};

function requestsReducer(state, action) {
  switch (action.type) {
    case "set": {
      return { ...state, ...action.payload };
    }
    default: {
      throw new Error(`Unhandled action type: ${action.type}`);
    }
  }
}
const requestsInitState = {
  domains: null,
  fields: null,
};
const toggleIsCascadeFiles = (setter) => {
  setter((state) => !state);
};

function EmployeeRequests() {
  const handleChangeZoneMethods = useForm();
  const [map] = useMap();
  const { view, graphicsLayerSelectedParcels, graphicsLayer } = map;
  const [esriUrls] = useEsriUrls();
  const [auth] = useAuth();
  const { roles, initRoles } = useRoles();
  const [requests, setRequests] = useState(null);

  const isAcceptedRef = useRef(null);
  const [files, setFiles] = useState([]);
  const [isCascadeFiles, setIsCascadeFiles] = useState(false);
  const {
    trigger: triggerZoneChange,
    register: registerZoneChange,
    formState: { errors: errorsZoneChange },
    getValues: getValuesZoneChange,
    setValue: setValueZoneChange,
    reset: resetZoneChange,
  } = useForm();

  const { zones } = useGetAllZones();
  
  const selectedZoneFormMethods = useForm({ mode: "onBlur" });
  const [selectedZoneModalDialogState, selectedZoneModalDispatchDialog] =
    useReducer(dialogReducer, dialogInitState);

  const [requestsState, requestsDispatch] = useReducer(
    requestsReducer,
    requestsInitState
  );

  let filterInjectQuery = "";
  if (roles.employee) {
    filterInjectQuery = `USERNAME = '${auth.userDetails?.details?.userName}'`;
  }

  const { methods, onSubmitOfEsri } = useFilter({
    fields: requestsState.fields,
    domains: requestsState.domains,
    featureLayer: requestsState.featureLayer,
    reducerOrState: "state",
    setState: setRequests,
    injectQuery: filterInjectQuery,
    queryFeaturesOptions: { orderByFields: ["created_date DESC"] },
  });
  const { register, handleSubmit, reset } = methods;

  const [, loadingDispatch] = useLoading();
  const [state, dispatch] = useReducer(selectedItemReducer, reducerInitValue);

  const getEmployeesRequests = async () => {
    if ((esriUrls.EditRegulationsRequests, view)) {
      let query = "STATUS = 1";
      if (roles.employee) {
        query += ` AND USERNAME = '${auth.userDetails?.details?.userName}'`;
      }
      try {
        handleLoading(loadingDispatch, true);
        const { domains, res, fields, serverFeatureLayer } = await getEsriData({
          token: auth.esriToken,
          view,
          layerId: esriUrls.EditRegulationsRequests,
          neededDomains: ["TYPE", "STATUS"],
          query,
          layer: process.env.REACT_APP_UserTables_Table,
          queryFeaturesOptions: {
            orderByFields: ["created_date DESC"],
          },
        });
        if (res.length) setRequests(res);
        requestsDispatch({
          type: "set",
          payload: { domains, fields, featureLayer: serverFeatureLayer },
        });
        await addNewLog({
          ipAddress: auth.ipAddress,
          hostname: auth.hostname,
          logDescription: `${generateTextFromJson({},"مسح قائمة الطلبات ")} `});    
        reset();
      } catch (error) {
        ErrorHandelFunctionApp(error)
      }
    }
    handleLoading(loadingDispatch, false);
  };

  useEffect(() => {
    if (initRoles) getEmployeesRequests();
  }, [view, esriUrls, auth, initRoles]);

  const getZoneChangeRequestData = async (requestId) => {
    try {
      const { res: zoneRequestRes } = await getEsriData({
        token: auth.esriToken,
        layerId: esriUrls.ZoningRequests,
        query: `REQUESTID = '${requestId}'`,
        layer: process.env.REACT_APP_UserTables_Table,
      });
      if (zoneRequestRes.length) return zoneRequestRes[0];
      NotificationManager.error("لا يوجد بيانات");
    } catch (error) {
      ErrorHandelFunctionApp(error)
    }
    return null;
  };
  const getParcelRequestData = async (requestId) => {
    try {
      const { res: parcelRequestRes } = await getEsriData({
        token: auth.esriToken,
        layerId: esriUrls.RequestParcelsRel,
        query: `REQUESTID = '${requestId}'`,
        layer: process.env.REACT_APP_UserTables_Table,
      });
      const parcelObjectIDs = parcelRequestRes.map(
        (parcel) => parcel.ParcelObjectID
      );
      const { res: parcelRequestResWithGeo } = await getEsriData({
        token: auth.esriToken,
        objectIds: parcelObjectIDs,
        layer: process.env.REACT_APP_UserTables_Table,
        layerId: esriUrls.featureParcelsIntersect,
        neededDomains: ["ZONE_ID"],
      });
      if (parcelRequestRes.length) return parcelRequestResWithGeo;
      NotificationManager.error("لا يوجد بيانات");
    } catch (error) {
      ErrorHandelFunctionApp(error)
    }
    return null;
  };

  const getFiles = async (selectedItem) => {
    try {
      handleLoading(loadingDispatch, true);
      const urlRequestParcelsRel = `${process.env.REACT_APP_SERVICE_ENDPOINT}/${process.env.REACT_APP_UserTables_Table}/FeatureServer/${esriUrls.EditRegulationsRequests}`;
      const regulationsRequestsLayer = new FeatureLayer({
        // URL to the service
        url: urlRequestParcelsRel,
      });
      const queryAttachmentsInfo =
        await regulationsRequestsLayer.queryAttachments({
          objectIds: [selectedItem.OBJECTID],
        });

      if (queryAttachmentsInfo[selectedItem.OBJECTID]?.length > 0) {
        setFiles(queryAttachmentsInfo[selectedItem.OBJECTID]);
      } else {
        setFiles([]);
      }
    } catch (error) {
      ErrorHandelFunctionApp(error)
    }
    handleLoading(loadingDispatch, false);
  };

  const handleOpenTicket = async (data) => {
    // get the data based on the type
    let selectedItem = null;
    let selectedZone = null;
    getFiles(data);
    if (data.TYPE === 2) {
      handleLoading(loadingDispatch, true);
      try {
        selectedItem = await getZoneChangeRequestData(data.OBJECTID);
        setValueZoneChange("ACTION_DESCRIPTION", data.ACTION_DESCRIPTION);
        selectedZone = zones.find(
          (zone) => zone.ZONE_ID === selectedItem.ZONE_ID
        );
      } catch (error) {
        ErrorHandelFunctionApp(error)
      }
      handleLoading(loadingDispatch, false);
      dispatch({
        type: "set",
        payload: {
          type: data.TYPE === 1 ? "parcelsChange" : "zoneChange",
          selectedItem,
          selectedZone,
          selectedRequest: data,
        },
      });
    }
    if (data.TYPE === 1) {
      handleLoading(loadingDispatch, true);
      const selectedParcels = await getParcelRequestData(data.OBJECTID);
      setValueZoneChange("ACTION_DESCRIPTION", data.ACTION_DESCRIPTION);
      handleLoading(loadingDispatch, false);
      handleZoom(selectedParcels, view, graphicsLayer);
      selectedZone = zones.find((zone) => zone.ZONE_ID === data.ZONE_ID);
      dispatch({
        type: "set",
        payload: {
          type: data.TYPE === 1 ? "parcelsChange" : "zoneChange",
          selectedItem,
          selectedParcels,
          selectedZone,
          selectedRequest: data,
        },
      });
    }
  };
  const handleClearOpenedTicket = () => {
    dispatch({
      type: "set",
      payload: {
        type: "",
        selectedItem: null,
        selectedZone: null,
      },
    });
  };

  // zone change functions
  const onSubmitZoneChange = async () => {
    const isAccepted = isAcceptedRef.current;
    const noError = await triggerZoneChange();
    if (noError) {
      const { ACTION_DESCRIPTION } = getValuesZoneChange();
      // selectedItem OBJECTID ZONE_ID
      // selectedZone
      // change request status based on isAccepted
      handleLoading(loadingDispatch, true);
      try {
        const urlRequestParcelsRel = `${process.env.REACT_APP_SERVICE_ENDPOINT}/${process.env.REACT_APP_UserTables_Table}/FeatureServer/${esriUrls.EditRegulationsRequests}`;
        await performActionOnFeature({
          url: urlRequestParcelsRel,
          objs: [
            {
              OBJECTID: state.selectedRequest.OBJECTID,
              ACTION_DESCRIPTION,
              status: isAccepted
                ? editRegulationsRequestsStatus["معتمد"]
                : editRegulationsRequestsStatus["مرفوض"],
            },
          ],
          action: "update",
          notificationMessages: {
            onSuccessMessage: "تم تحديث الطلب",
            onErrorMessage: "حدث خطأ ما",
          },
        });

        // change the original zone if isAccepted === true
        if (isAccepted) {
          const urlChangeableZoningDesc = `${process.env.REACT_APP_SERVICE_ENDPOINT}/${process.env.REACT_APP_UserTables_Table}/FeatureServer/${esriUrls.changeableZoningDesc}`;
          await performActionOnFeature({
            url: urlChangeableZoningDesc,
            objs: [
              {
                ...state.selectedItem,
                OBJECTID: state.selectedZone.OBJECTID,
              },
            ],
            action: "update",
            notificationMessages: {
              onSuccessMessage: "تم تحديث الحكم بنجاح",
              onErrorMessage: "حدث خطأ ما",
            },
          });
          if (isCascadeFiles) {
            const query = `ZONE_ID = ${state.selectedItem.ZONE_ID} AND DLS_KEY <> ''`;
            const { res: parcels } = await getEsriData({
              token: auth.esriToken,
              layerId: esriUrls.Parcels_Intersect,
              layer: process.env.REACT_APP_PetraLayers_Table,
              featureOrMap: "MapServer",
              query,
              outFields: "DLS_KEY",
              returnDistinctValues: true,
              returnGeometry: false,
            });
            const dlsKeyArray = parcels.map((item) => item.DLS_KEY);
            await api.post("/pdf/print/lock", {
              dlsKey:dlsKeyArray[0],
              lockStatus:LockTypeEnum.prevent,
              deleteDocs:false
            });      
          }
        }
        dispatch({ payload: reducerInitValue, type: "set" });
        resetZoneChange({});
        await getEmployeesRequests();
        await addNewLog({
          ipAddress: auth.ipAddress,
          hostname: auth.hostname,
          logDescription: isAccepted
            ? `قبول طلب تعديل أحكام استعمال`
            : "رفض طلب تعديل أحكام استعمال",
        });
      } catch (error) {
        ErrorHandelFunctionApp(error)
      }
      handleLoading(loadingDispatch, false);
    }
  };

  // parcel change functions

  const [ParcelEditZoneModalDialogState, ParcelEditZoneModalDispatchDialog] =
    useReducer(dialogReducer, dialogInitState);
  const [selectedParcelZone, setSelectedParcelZone] = useState(null);
  const selectedZoneDialogToggle = (data) => {
    if (data) {
      const selectedZone = zones.find((item) => item.ZONE_ID === data.ZONE_ID);
      setSelectedParcelZone(selectedZone);
    }
    selectedZoneModalDispatchDialog({ type: "TOGGLE" });
  };
  const toggleZoneModalDialog = (data) => {
    setIsCascadeFiles(false);
    if (data) {
      const selectedZone = zones.find((item) => item.ZONE_ID === data.ZONE_ID);
      setSelectedParcelZone(selectedZone);
    }
    ParcelEditZoneModalDispatchDialog({ type: "TOGGLE" });
  };

  const editParcelZoom = (data) => {
    handleZoom([data], view, graphicsLayerSelectedParcels, {
      color: [11, 250, 47, 1],
      width: 2,
    });
  };
  const selectedParcelZoneFormMethods = useForm();

  const onSubmitParcelsChange = async () => {
    const isAccepted = isAcceptedRef.current;
    const noError = await triggerZoneChange();
    if (noError) {
      if (noError) {
        const { ACTION_DESCRIPTION } = getValuesZoneChange();
        // selectedItem OBJECTID ZONE_ID
        // selectedZone
        // change request status based on isAccepted
        handleLoading(loadingDispatch, true);
        try {
          const urlRequestParcelsRel = `${process.env.REACT_APP_SERVICE_ENDPOINT}/${process.env.REACT_APP_UserTables_Table}/FeatureServer/${esriUrls.EditRegulationsRequests}`;
          await performActionOnFeature({
            url: urlRequestParcelsRel,
            objs: [
              {
                OBJECTID: state.selectedRequest.OBJECTID,
                ACTION_DESCRIPTION,
                status: isAccepted
                  ? editRegulationsRequestsStatus["معتمد"]
                  : editRegulationsRequestsStatus["مرفوض"],
              },
            ],
            action: "update",
            notificationMessages: {
              onSuccessMessage: "تم تحديث الطلب",
              onErrorMessage: "حدث خطأ ما",
            },
          });

          // change the original zone if isAccepted === true
          if (isAccepted) {
            handleLoading(loadingDispatch, false);
            const updatedParcelZones = state.selectedParcels.map((parcel) => ({
              OBJECTID: parcel.OBJECTID,
              ZONE_ID: state.selectedZone.ZONE_ID,
            }));
            const urlChangeableParcels = `${process.env.REACT_APP_SERVICE_ENDPOINT}/${process.env.REACT_APP_UserTables_Table}/FeatureServer/${esriUrls.featureParcelsIntersect}`;
            await performActionOnFeature({
              url: urlChangeableParcels,
              objs: updatedParcelZones,
              action: "update",
              notificationMessages: {
                onSuccessMessage: "تم تحديث الحكم بنجاح",
                onErrorMessage: "حدث خطأ ما",
              },
            });
          }
          if (isCascadeFiles) {
            const dlsKeyArray = state.selectedParcels.map(
              (parcel) => parcel.DLS_KEY
            );
            await api.post("/pdf/print/lock", {
              dlsKey:dlsKeyArray[0],
              lockStatus:LockTypeEnum.prevent,
              deleteDocs:false
            });      
          }
          dispatch({ payload: reducerInitValue, type: "set" });
          resetZoneChange({});
          await getEmployeesRequests();
          await addNewLog({
            ipAddress: auth.ipAddress,
            hostname: auth.hostname,
            logDescription: isAccepted
              ? `قبول طلب تعديل صفة استعمال`
              : "رفض طلب تعديل صفة استعمال",
          });
        } catch (error) {
          ErrorHandelFunctionApp(error)
        }
        handleLoading(loadingDispatch, false);
      }
    }
  };

  const [confirmChangeDialogState, confirmChangeDialogDispatch] = useReducer(
    dialogReducer,
    dialogInitState
  );
  const confirmChangeDialogToggle = async (submit, isAccepted) => {
    setIsCascadeFiles(false);
    if (submit && state.type === "parcelsChange") {
      //
      onSubmitParcelsChange();
    }
    if (submit && state.type === "zoneChange") {
      onSubmitZoneChange();
    }
    // if isAccepted passed a valid value
    if (isAccepted === true || isAccepted === false)
      isAcceptedRef.current = isAccepted;

    const noError = await triggerZoneChange();
    if (!noError) return;

    confirmChangeDialogDispatch({ type: "TOGGLE" });
  };

  // files
  const [filesDialogState, filesDispatchDialog] = useReducer(
    dialogReducer,
    dialogInitState
  );
  const toggleFilesDialog = () => {
    filesDispatchDialog({ type: "TOGGLE" });
  };

  // ----

  if (!state.selectedItem && !state.type)
    return (
      <>
        <h2 className="content__title title mt-3">قائمة الطلبات</h2>
        <div>
          <form onSubmit={handleSubmit(onSubmitOfEsri)}>
            <p className="mb-0">الفترة الزمنية</p>
            <div className="table__filter__period">
              <Form.Group
                className="input input-md date-input"
                controlId="created_date_from"
              >
                <Form.Label>من</Form.Label>
                <Form.Control type="date" {...register("created_date_from")} />
              </Form.Group>
              <Form.Group
                className="input input-md date-input"
                controlId="created_date_to"
              >
                <Form.Label>إلى</Form.Label>
                <Form.Control type="date" {...register("created_date_to")} />
              </Form.Group>
            </div>
            <Form.Group className="mt-3 input input-md" controlId="TYPE">
              <Form.Label>نوع الطلب</Form.Label>
              <Form.Select {...register("TYPE")}>
                <option value="">الرجاء الاختيار</option>
                {requestsState?.domains?.TYPE?.map((type) => (
                  <option key={type.code} value={type.code}>
                    {type.name}
                  </option>
                ))}
              </Form.Select>
            </Form.Group>
            <Form.Group className="mt-3 input input-md" controlId="STATUS">
              <Form.Label>حالة الطلب</Form.Label>
              <Form.Select {...register("STATUS")}>
                <option value="">الرجاء الاختيار</option>
                {requestsState?.domains?.STATUS?.map((status) => (
                  <option key={status.code} value={status.code}>
                    {status.name}
                  </option>
                ))}
              </Form.Select>
            </Form.Group>
            <div className="mt-3 d-flex">
              <button
                type="submit"
                className="btn btn--primary ms-3"
                style={{ flex: "1" }}
              >
                بحث
              </button>
              <button
                type="button"
                onClick={getEmployeesRequests}
                className="btn btn--red"
                style={{ flex: "1" }}
              >
                مسح
              </button>
            </div>
          </form>
          {requests && requests.length > 0 ? (
            <div className="employee-requests">
              {requests?.map((request) => (
                <EmployeeRequestsCard
                  key={request.OBJECTID}
                  request={request}
                  handleOnClick={handleOpenTicket}
                />
              ))}
            </div>
          ) : (
            <p className="text-center mt-5">لا يوجد بيانات لعرضها</p>
          )}
        </div>
      </>
    );

  if (state.type === "parcelsChange")
    return (
      <>
        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <h2 className="content__title title mt-3">تعديل صفة استعمال</h2>
          <button type="button" onClick={handleClearOpenedTicket}>
            <ArrowLeft />
          </button>
        </div>
        {state.selectedRequest.STATUS ===
          editRegulationsRequestsStatus["تحت المعالجة"] && (
          <button
            type="button"
            className="btn btn--primary mb-3"
            onClick={selectedZoneDialogToggle.bind(this, state.selectedZone)}
          >
            صفة الإستعمال المراد التحديث لها
          </button>
        )}
        <button
          type="button"
          className="btn btn--primary mb-3 me-2"
          onClick={toggleFilesDialog}
        >
          المرفقات ({files.length})
        </button>
        <Form.Group
          className="mb-3 input input-md"
          controlId="ACTION_DESCRIPTION"
        >
          <Form.Label
            className={
              state.selectedRequest.STATUS ===
                editRegulationsRequestsStatus["تحت المعالجة"] && "required"
            }
          >
            وصف و سبب القرار
          </Form.Label>
          <Form.Control
            autoComplete="off"
            as="textarea"
            disabled={
              state.selectedRequest.STATUS !==
                editRegulationsRequestsStatus["تحت المعالجة"] || !roles.manager
            }
            type="text"
            {...registerZoneChange("ACTION_DESCRIPTION", {
              required: "الرجاء ادخال الحقل",
              value: state.selectedRequest.ACTION_DESCRIPTION,
            })}
          />
          {errorsZoneChange.ACTION_DESCRIPTION && (
            <Form.Text className="text-danger">
              {errorsZoneChange.ACTION_DESCRIPTION.message}
            </Form.Text>
          )}
        </Form.Group>
        {state?.selectedParcels.map((searchedParcel) => (
          <EditParcelZoneCard
            key={`${searchedParcel.OBJECTID}-${searchedParcel.DLS_KEY}`}
            searchedParcel={searchedParcel}
            zoneEditParcelZoom={editParcelZoom}
            toggleDialog={toggleZoneModalDialog}
          />
        ))}
        {state.selectedRequest.STATUS ===
          editRegulationsRequestsStatus["تحت المعالجة"] &&
          roles.manager && (
            <div
              className="sticky-button grid grid-of-2"
              style={{ gap: "1em" }}
            >
              <button
                type="submit"
                className=" btn btn--green w-100"
                onClick={confirmChangeDialogToggle.bind(this, false, true)}
              >
                قبول
              </button>
              <button
                type="submit"
                className=" btn btn--red w-100"
                onClick={confirmChangeDialogToggle.bind(this, false, false)}
              >
                رفض
              </button>
            </div>
          )}
        <Dialog
          state={ParcelEditZoneModalDialogState}
          dispatch={ParcelEditZoneModalDispatchDialog}
          footer={false}
          title="التفاصيل"
          closeButton
          centered
        >
          {selectedParcelZone && (
            <ParcelLaws
              law={selectedParcelZone}
              methods={selectedParcelZoneFormMethods}
              disabled
            />
          )}
        </Dialog>
        <Dialog
          state={selectedZoneModalDialogState}
          dispatch={selectedZoneModalDispatchDialog}
          footer={false}
          title="الحكم الجديد المراد التحديث اليه"
          closeButton
          centered
        >
          {state.selectedZone && (
            <ParcelLaws
              law={state.selectedZone}
              methods={selectedZoneFormMethods}
              disabled
            />
          )}
        </Dialog>
        <Dialog
          state={confirmChangeDialogState}
          dispatch={confirmChangeDialogDispatch}
          footer
          // eslint-disable-next-line react/jsx-no-bind
          confirmFunction={confirmChangeDialogToggle.bind(this, true)}
          title="هل انت متأكد من الإجراء؟"
          closeButton
          centered
        >
          <Form.Group className="mb-3" controlId="cascadeFiles">
            <Form.Check
              checked={isCascadeFiles}
              // eslint-disable-next-line react/jsx-no-bind
              onChange={toggleIsCascadeFiles.bind(this, setIsCascadeFiles)}
              type="checkbox"
              label="تعطيل المخططات المرتبطة بهذا التعديل"
            />
          </Form.Group>
        </Dialog>
        <Dialog
          state={filesDialogState}
          dispatch={filesDispatchDialog}
          footer={false}
          title="مرفقات الطلب"
          closeButton
          centered
        >
          <FilesModal
            files={files}
            setFiles={setFiles}
            addable={false}
            downloadable
          />
        </Dialog>
      </>
    );
  if (state.type === "zoneChange")
    return (
      <>
        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <h2 className="content__title title mt-3">تعديل احكام استعمال</h2>
          <button type="button" onClick={handleClearOpenedTicket}>
            <ArrowLeft />
          </button>
        </div>
        {state.selectedRequest.STATUS ===
          editRegulationsRequestsStatus["تحت المعالجة"] && (
          <button
            type="button"
            className="btn btn--primary mb-3"
            onClick={selectedZoneDialogToggle.bind()}
          >
            عرض الأحكام الأصلية
          </button>
        )}
        <button
          type="button"
          className="btn btn--primary mb-3 me-2"
          onClick={toggleFilesDialog}
        >
          المرفقات ({files.length})
        </button>
        <Form.Group
          className="mb-3 input input-md"
          controlId="ACTION_DESCRIPTION"
        >
          <Form.Label
            className={
              state.selectedRequest.STATUS ===
                editRegulationsRequestsStatus["تحت المعالجة"] && "required"
            }
          >
            وصف و سبب القرار
          </Form.Label>
          <Form.Control
            autoComplete="off"
            as="textarea"
            disabled={
              state.selectedRequest.STATUS !==
                editRegulationsRequestsStatus["تحت المعالجة"] || !roles.manager
            }
            type="text"
            {...registerZoneChange("ACTION_DESCRIPTION", {
              required: "الرجاء ادخال الحقل",
              value: state.selectedRequest.ACTION_DESCRIPTION,
            })}
          />
          {errorsZoneChange.ACTION_DESCRIPTION && (
            <Form.Text className="text-danger">
              {errorsZoneChange.ACTION_DESCRIPTION.message}
            </Form.Text>
          )}
        </Form.Group>
        <div className="submit-zone-change-request">
          <ParcelLaws
            law={state.selectedItem}
            lawToCompare={state.selectedZone}
            methods={handleChangeZoneMethods}
            disabled
          />
        </div>
        {state.selectedRequest.STATUS ===
          editRegulationsRequestsStatus["تحت المعالجة"] &&
          roles.manager && (
            <div
              className="sticky-button grid grid-of-2"
              style={{ gap: "1em" }}
            >
              <button
                type="submit"
                className=" btn btn--green w-100"
                onClick={confirmChangeDialogToggle.bind(this, false, true)}
              >
                قبول
              </button>
              <button
                type="submit"
                className=" btn btn--red w-100"
                onClick={confirmChangeDialogToggle.bind(this, false, false)}
              >
                رفض
              </button>
            </div>
          )}
        <Dialog
          state={selectedZoneModalDialogState}
          dispatch={selectedZoneModalDispatchDialog}
          footer={false}
          title="الأحكام الأصلية"
          closeButton
          centered
        >
          {state.selectedZone && (
            <ParcelLaws
              law={state.selectedZone}
              methods={selectedZoneFormMethods}
              disabled
            />
          )}
        </Dialog>
        <Dialog
          state={confirmChangeDialogState}
          dispatch={confirmChangeDialogDispatch}
          footer
          // eslint-disable-next-line react/jsx-no-bind
          confirmFunction={confirmChangeDialogToggle.bind(this, true)}
          bodyClassName="py-0"
          title="هل انت متأكد من الإجراء؟"
          closeButton
          centered
        >
          <Form.Group className="mb-3" controlId="cascadeFiles">
            <Form.Check
              checked={isCascadeFiles}
              // eslint-disable-next-line react/jsx-no-bind
              onChange={toggleIsCascadeFiles.bind(this, setIsCascadeFiles)}
              type="checkbox"
              label="تعطيل المخططات المرتبطة بهذا التعديل"
            />
          </Form.Group>
        </Dialog>
        <Dialog
          state={filesDialogState}
          dispatch={filesDispatchDialog}
          footer={false}
          title="مرفقات الطلب"
          closeButton
          centered
        >
          <FilesModal
            files={files}
            setFiles={setFiles}
            addable={false}
            downloadable
          />
        </Dialog>
      </>
    );
}

export default EmployeeRequests;
